<div class="main-container" id="evaluator-dashboard">
  <div class="header-container">
    <app-mmp-main-header></app-mmp-main-header>
  </div>
  <div class="dashboard-container">
    <div class="welcome-section">
      <div class="welcome-left-section">
        <div class="welcome-heading">
          Welcome, {{ currentUserName }}! <span class="wave">👋</span>
        </div>
        <div class="welcome-message">
          Let’s track your progress and resolve the pending tasks
        </div>
      </div>
      @if (formattedLastSyncTime) {
        <div class="sync-date">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_sync_date)">
              <path
                d="M2.25 9C2.25 9.88642 2.42459 10.7642 2.76381 11.5831C3.10303 12.4021 3.60023 13.1462 4.22703 13.773C4.85382 14.3998 5.59794 14.897 6.41689 15.2362C7.23583 15.5754 8.11358 15.75 9 15.75C9.88642 15.75 10.7642 15.5754 11.5831 15.2362C12.4021 14.897 13.1462 14.3998 13.773 13.773C14.3998 13.1462 14.897 12.4021 15.2362 11.5831C15.5754 10.7642 15.75 9.88642 15.75 9C15.75 8.11358 15.5754 7.23583 15.2362 6.41689C14.897 5.59794 14.3998 4.85382 13.773 4.22703C13.1462 3.60023 12.4021 3.10303 11.5831 2.76381C10.7642 2.42459 9.88642 2.25 9 2.25C8.11358 2.25 7.23583 2.42459 6.41689 2.76381C5.59794 3.10303 4.85382 3.60023 4.22703 4.22703C3.60023 4.85382 3.10303 5.59794 2.76381 6.41689C2.42459 7.23583 2.25 8.11358 2.25 9Z"
                stroke="#5B5B5B"
                stroke-width="1.125"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9 9H11.625"
                stroke="#5B5B5B"
                stroke-width="1.125"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9 5.25V9"
                stroke="#5B5B5B"
                stroke-width="1.125"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_sync_date">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>

          Last Synced:
          {{ formattedLastSyncTime }}
        </div>
      }
    </div>
    <div class="widget-section">
      <div class="widget-container">
        <!-- Total Prospects Widget -->
        <button
          type="button"
          class="widget total-prospects"
          [ngClass]="{
            active:
              ComparisonNormalizer.string(selectedWidget) === 'total-prospects',
          }"
          (click)="setActiveWidget('total-prospects')"
          [attr.aria-pressed]="
            ComparisonNormalizer.string(selectedWidget) === 'total-prospects'
          "
        >
          <div class="widget-content">
            <div class="horizontal-line">
              <div class="widget-icon">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  loading="lazy"
                >
                  <g clip-path="url(#clip0_1097_3292)">
                    <path
                      d="M10.502 2.25V5.25C10.502 5.44891 10.581 5.63968 10.7216 5.78033C10.8623 5.92098 11.053 6 11.252 6H14.252"
                      stroke="#006580"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.752 15.75H5.25195C4.85413 15.75 4.4726 15.592 4.19129 15.3107C3.90999 15.0294 3.75195 14.6478 3.75195 14.25V3.75C3.75195 3.35218 3.90999 2.97064 4.19129 2.68934C4.4726 2.40804 4.85413 2.25 5.25195 2.25H10.502L14.252 6V14.25C14.252 14.6478 14.0939 15.0294 13.8126 15.3107C13.5313 15.592 13.1498 15.75 12.752 15.75Z"
                      stroke="#006580"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.75 12.75H11.25"
                      stroke="#006580"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.75 9.75H11.25"
                      stroke="#006580"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1097_3292">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span class="widget-title">Total Prospects</span>
            </div>

            <div class="widget-info">
              <span class="widget-value">{{ statusCounts?.Total }}</span>
              <span class="widget-subtitle">All active prospects</span>
            </div>
          </div>
        </button>

        <!-- New Widget -->
        <button
          type="button"
          class="widget new"
          [ngClass]="{
            active: ComparisonNormalizer.string(selectedWidget) === 'new',
          }"
          (click)="setActiveWidget('new')"
          [attr.aria-pressed]="
            ComparisonNormalizer.string(selectedWidget) === 'new'
          "
        >
          <div class="widget-content">
            <div class="horizontal-line">
              <div class="widget-icon new">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  loading="lazy"
                >
                  <g clip-path="url(#clip0_3906_8152)">
                    <path
                      d="M10.5 2.25V5.25C10.5 5.44891 10.579 5.63968 10.7197 5.78033C10.8603 5.92098 11.0511 6 11.25 6H14.25"
                      stroke="#0073B5"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.75 15.75H5.25C4.85218 15.75 4.47064 15.592 4.18934 15.3107C3.90804 15.0294 3.75 14.6478 3.75 14.25V3.75C3.75 3.35218 3.90804 2.97064 4.18934 2.68934C4.47064 2.40804 4.85218 2.25 5.25 2.25H10.5L14.25 6V14.25C14.25 14.6478 14.092 15.0294 13.8107 15.3107C13.5294 15.592 13.1478 15.75 12.75 15.75Z"
                      stroke="#0073B5"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9 8.25V12.75"
                      stroke="#0073B5"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.75 10.5H11.25"
                      stroke="#0073B5"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3906_8152">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span class="widget-title">New</span>
            </div>
            <div class="widget-info">
              <span class="widget-value">{{ statusCounts?.New }}</span>
              <span class="widget-subtitle">Prospect not yet evaluated</span>
            </div>
          </div>
        </button>

        <!-- Reopen Widget -->
        <button
          type="button"
          class="widget reopen"
          [ngClass]="{
            active: ComparisonNormalizer.string(selectedWidget) === 'reopen',
          }"
          (click)="setActiveWidget('reopen')"
          [attr.aria-pressed]="
            ComparisonNormalizer.string(selectedWidget) === 'reopen'
          "
        >
          <div class="widget-content">
            <div class="horizontal-line">
              <div class="widget-icon reopen">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  loading="lazy"
                >
                  <g clip-path="url(#clip0_3911_8164)">
                    <path
                      d="M15 8.25002C14.8166 6.93019 14.2043 5.70727 13.2575 4.76965C12.3107 3.83202 11.0818 3.23171 9.76025 3.06119C8.43869 2.89066 7.09772 3.15939 5.9439 3.82596C4.79009 4.49253 3.88744 5.51998 3.375 6.75002M3 3.75002V6.75002H6"
                      stroke="#4055A5"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M3 9.75C3.18342 11.0698 3.7957 12.2928 4.74252 13.2304C5.68934 14.168 6.91818 14.7683 8.23975 14.9388C9.56131 15.1094 10.9023 14.8406 12.0561 14.1741C13.2099 13.5075 14.1126 12.48 14.625 11.25M15 14.25V11.25H12"
                      stroke="#4055A5"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.25 9C8.25 9.19891 8.32902 9.38968 8.46967 9.53033C8.61032 9.67098 8.80109 9.75 9 9.75C9.19891 9.75 9.38968 9.67098 9.53033 9.53033C9.67098 9.38968 9.75 9.19891 9.75 9C9.75 8.80109 9.67098 8.61032 9.53033 8.46967C9.38968 8.32902 9.19891 8.25 9 8.25C8.80109 8.25 8.61032 8.32902 8.46967 8.46967C8.32902 8.61032 8.25 8.80109 8.25 9Z"
                      stroke="#4055A5"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3911_8164">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span class="widget-title">Reopen</span>
            </div>
            <div class="widget-info">
              <span class="widget-value">{{ statusCounts?.Re_Open }}</span>
              <span class="widget-subtitle">Reopened for review</span>
            </div>
          </div>
        </button>

        <!-- Open Now Widget -->
        <button
          type="button"
          class="widget open"
          [ngClass]="{
            active: ComparisonNormalizer.string(selectedWidget) === 'open',
          }"
          (click)="setActiveWidget('open')"
          [attr.aria-pressed]="
            ComparisonNormalizer.string(selectedWidget) === 'open'
          "
        >
          <div class="widget-content">
            <div class="horizontal-line">
              <div class="widget-icon open">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  loading="lazy"
                >
                  <g clip-path="url(#clip0_3911_8192)">
                    <path
                      d="M10.4999 2.25V5.25C10.4999 5.44891 10.579 5.63968 10.7196 5.78033C10.8603 5.92098 11.051 6 11.2499 6H14.2499"
                      stroke="#098396"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.7499 15.75H5.24994C4.85211 15.75 4.47058 15.592 4.18928 15.3107C3.90797 15.0294 3.74994 14.6478 3.74994 14.25V3.75C3.74994 3.35218 3.90797 2.97064 4.18928 2.68934C4.47058 2.40804 4.85211 2.25 5.24994 2.25H10.4999L14.2499 6V14.25C14.2499 14.6478 14.0919 15.0294 13.8106 15.3107C13.5293 15.592 13.1478 15.75 12.7499 15.75Z"
                      stroke="#098396"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.08035 11.2038C6.03885 11.1421 6.0181 11.1113 6.00648 11.0638C5.99776 11.0281 5.99776 10.9719 6.00648 10.9362C6.0181 10.8887 6.03885 10.8579 6.08035 10.7962C6.42332 10.2871 7.44419 9 8.99994 9C10.5557 9 11.5766 10.2871 11.9195 10.7962C11.961 10.8579 11.9818 10.8887 11.9934 10.9362C12.0021 10.9719 12.0021 11.0281 11.9934 11.0638C11.9818 11.1113 11.961 11.1421 11.9195 11.2038C11.5766 11.7129 10.5557 13 8.99994 13C7.44419 13 6.42332 11.7129 6.08035 11.2038Z"
                      stroke="#098396"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.99994 12C9.55224 12 9.99994 11.5523 9.99994 11C9.99994 10.4477 9.55224 10 8.99994 10C8.44764 10 7.99994 10.4477 7.99994 11C7.99994 11.5523 8.44764 12 8.99994 12Z"
                      fill="#098396"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3911_8192">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span class="widget-title">Open</span>
            </div>
            <div class="widget-info">
              <span class="widget-value">{{ statusCounts?.Open }}</span>
              <span class="widget-subtitle">Evaluation in progress</span>
            </div>
          </div>
        </button>

        <!-- Pending Widget -->
        <button
          type="button"
          class="widget pending"
          [ngClass]="{
            active: ComparisonNormalizer.string(selectedWidget) === 'pending',
          }"
          (click)="setActiveWidget('pending')"
          [attr.aria-pressed]="
            ComparisonNormalizer.string(selectedWidget) === 'pending'
          "
        >
          <div class="widget-content">
            <div class="horizontal-line">
              <div class="widget-icon pending">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  loading="lazy"
                >
                  <g clip-path="url(#clip0_3901_7557)">
                    <path
                      d="M15.7379 9.40125C15.8194 8.03385 15.4828 6.67405 14.7731 5.50246C14.0633 4.33088 13.0139 3.40297 11.7642 2.84199C10.5145 2.28102 9.12372 2.11353 7.77659 2.36178C6.42946 2.61003 5.18974 3.26226 4.22211 4.23184C3.25448 5.20142 2.60474 6.44246 2.3592 7.79009C2.11367 9.13772 2.28396 10.5282 2.84745 11.7767C3.41094 13.0253 4.34096 14.0728 5.51398 14.7802C6.68699 15.4876 8.04747 15.8214 9.4147 15.7372"
                      stroke="#BA5100"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9 5.25V9L11.25 11.25"
                      stroke="#BA5100"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.25 16.5L14.25 12"
                      stroke="#BA5100"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12 14.25L14.25 12L16.5 14.25"
                      stroke="#BA5100"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3901_7557">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span class="widget-title">Pending</span>
            </div>
            <div class="widget-info">
              <span class="widget-value">{{
                statusCounts?.pending_external_feedback
              }}</span>
              <span class="widget-subtitle">Waiting for external feedback</span>
            </div>
          </div>
        </button>

        <!-- In Complete Widget -->
        <button
          type="button"
          class="widget incomplete"
          [ngClass]="{
            active:
              ComparisonNormalizer.string(selectedWidget) === 'incomplete',
          }"
          (click)="setActiveWidget('incomplete')"
          [attr.aria-pressed]="
            ComparisonNormalizer.string(selectedWidget) === 'incomplete'
          "
        >
          <div class="widget-content">
            <div class="horizontal-line">
              <div class="widget-icon incomplete">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  loading="lazy"
                >
                  <g clip-path="url(#clip0_3911_8174)">
                    <path
                      d="M10.5 2.25V5.25C10.5 5.44891 10.579 5.63968 10.7197 5.78033C10.8603 5.92098 11.0511 6 11.25 6H14.25"
                      stroke="#FA0000"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.75 15.75H5.25C4.85218 15.75 4.47064 15.592 4.18934 15.3107C3.90804 15.0294 3.75 14.6478 3.75 14.25V3.75C3.75 3.35218 3.90804 2.97064 4.18934 2.68934C4.47064 2.40804 4.85218 2.25 5.25 2.25H10.5L14.25 6V14.25C14.25 14.6478 14.092 15.0294 13.8107 15.3107C13.5294 15.592 13.1478 15.75 12.75 15.75Z"
                      stroke="#FA0000"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.5 9L10.5 12M10.5 9L7.5 12"
                      stroke="#FA0000"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3911_8174">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span class="widget-title">Incomplete</span>
            </div>
            <div class="widget-info">
              <span class="widget-value">{{
                statusCounts?.request_incomplete_response
              }}</span>
              <span class="widget-subtitle">Unfinished evaluation</span>
            </div>
          </div>
        </button>

        <!-- Completed Widget -->
        <button
          type="button"
          class="widget closed"
          [ngClass]="{
            active: ComparisonNormalizer.string(selectedWidget) === 'closed',
          }"
          (click)="setActiveWidget('closed')"
          [attr.aria-pressed]="
            ComparisonNormalizer.string(selectedWidget) === 'closed'
          "
        >
          <div class="widget-content">
            <div class="horizontal-line">
              <div class="widget-icon closed">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  loading="lazy"
                >
                  <g clip-path="url(#clip0_3901_8096)">
                    <path
                      d="M6.42047 2.76758C5.60153 3.10657 4.85737 3.60352 4.23047 4.23008"
                      stroke="#088E6D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.7675 6.41992C2.42742 7.23765 2.25158 8.1143 2.25 8.99992"
                      stroke="#088E6D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.76746 11.5801C3.10645 12.399 3.6034 13.1432 4.22996 13.7701"
                      stroke="#088E6D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.42004 15.2324C7.23777 15.5725 8.11442 15.7483 9.00004 15.7499"
                      stroke="#088E6D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.5801 15.232C12.399 14.893 13.1432 14.3961 13.7701 13.7695"
                      stroke="#088E6D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.2325 11.58C15.5726 10.7623 15.7485 9.88562 15.75 9"
                      stroke="#088E6D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.232 6.42047C14.893 5.60153 14.3961 4.85737 13.7695 4.23047"
                      stroke="#088E6D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.58 2.7675C10.7623 2.42742 9.88562 2.25158 9 2.25"
                      stroke="#088E6D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.75 9L8.25 10.5L11.25 7.5"
                      stroke="#088E6D"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_3901_8096">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span class="widget-title">Completed</span>
            </div>
            <div class="widget-info">
              <span class="widget-value">{{ statusCounts?.Closed }}</span>
              <span class="widget-subtitle">Completed prospects list</span>
            </div>
          </div>
        </button>
      </div>
    </div>
    <div class="table-section">
      <div class="table-header">
        <div class="actions">
          <div class="title">Total Prospects</div>
          <div class="search-box">
            <div class="search-input-wrapper">
              <div class="search-icon-wrapper">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  loading="lazy"
                >
                  <g clip-path="url(#clip0_1097_2863)">
                    <path
                      d="M2 6.66667C2 7.2795 2.12071 7.88634 2.35523 8.45252C2.58975 9.01871 2.93349 9.53316 3.36683 9.9665C3.80018 10.3998 4.31462 10.7436 4.88081 10.9781C5.447 11.2126 6.05383 11.3333 6.66667 11.3333C7.2795 11.3333 7.88634 11.2126 8.45252 10.9781C9.01871 10.7436 9.53316 10.3998 9.9665 9.9665C10.3998 9.53316 10.7436 9.01871 10.9781 8.45252C11.2126 7.88634 11.3333 7.2795 11.3333 6.66667C11.3333 6.05383 11.2126 5.447 10.9781 4.88081C10.7436 4.31462 10.3998 3.80018 9.9665 3.36683C9.53316 2.93349 9.01871 2.58975 8.45252 2.35523C7.88634 2.12071 7.2795 2 6.66667 2C6.05383 2 5.447 2.12071 4.88081 2.35523C4.31462 2.58975 3.80018 2.93349 3.36683 3.36683C2.93349 3.80018 2.58975 4.31462 2.35523 4.88081C2.12071 5.447 2 6.05383 2 6.66667Z"
                      stroke="#030213"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14 14L10 10"
                      stroke="#030213"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1097_2863">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <input
                type="text"
                placeholder="Search prospects, case number and program..."
                [formControl]="searchControl"
                class="search-input"
                aria-label="Search prospects, case number and program"
              />
            </div>
            <button
              class="filter-btn"
              title="Filter"
              (click)="openFilterDialog()"
            >
              @if (hasActiveFilters()) {
                <span class="filter-indicator"></span>
              }

              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                loading="lazy"
              >
                <g clip-path="url(#clip0_1097_2869)">
                  <path
                    d="M3 3H15V4.629C14.9999 5.02679 14.8418 5.40826 14.5605 5.6895L11.25 9V14.25L6.75 15.75V9.375L3.39 5.679C3.13909 5.40294 3.00004 5.0433 3 4.67025V3Z"
                    stroke="#006580"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1097_2869">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
            <!-- Add Clear Filters button -->
            @if (hasActiveFilters()) {
              <button
                class="clear-filters-btn"
                (click)="clearFilters()"
                aria-label="Clear Filters"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  loading="lazy"
                >
                  <path
                    d="M12 4L4 12"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4 4L12 12"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Clear Filters
              </button>
            }
          </div>
        </div>
        <div class="view-section">
          <div class="toolbar">
            <button
              class="spacing-toggle"
              [class.active]="isComfortable"
              (click)="toggleSpacing()"
              aria-label="Toggle table spacing"
            >
              <svg
                width="56"
                height="30"
                viewBox="0 0 56 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                loading="lazy"
              >
                <rect width="56" height="30" rx="6" fill="#CEECF2" />
                <rect
                  class="knob"
                  x="3"
                  y="3"
                  width="24"
                  height="24"
                  rx="4"
                  fill="white"
                />

                <g clip-path="url(#clip0)">
                  <path
                    d="M9.7 9H20.3"
                    stroke="#006580"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M9.7 13H20.3"
                    stroke="#006580"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M9.7 17H20.3"
                    stroke="#006580"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M9.7 21H20.3"
                    stroke="#006580"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </g>

                <g opacity="0.5" clip-path="url(#clip1)">
                  <path
                    d="M35.7 20.3H46.3"
                    stroke="#006580"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M35.7 15H46.3"
                    stroke="#006580"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                  <path
                    d="M35.7 9.7H46.3"
                    stroke="#006580"
                    stroke-width="1.5"
                    stroke-linecap="round"
                  />
                </g>

                <defs>
                  <clipPath id="clip0">
                    <rect width="16" height="16" transform="translate(7 7)" />
                  </clipPath>
                  <clipPath id="clip1">
                    <rect width="16" height="16" transform="translate(33 7)" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Skeleton Loader -->
      @if (isLoading) {
        <div
          class="skeleton-loader"
          [ngClass]="isComfortable ? 'comfortable-div' : 'compact-div'"
        >
          <div class="skeleton-row header">
            @for (col of displayedColumns; track col) {
              <div class="skeleton-cell"></div>
            }
          </div>
          @for (i of skeletonRows; track i) {
            <div class="skeleton-row">
              @for (col of displayedColumns; track col) {
                <div class="skeleton-cell"></div>
              }
            </div>
          }
        </div>
      }

      <div class="table-responsive">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          #sort="matSort"
          class="mat-elevation-z8 prospects-table"
          [ngClass]="isComfortable ? 'comfortable' : 'compact'"
        >
          <!-- Prospects Column -->
          <ng-container matColumnDef="prospect">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="prospect">
              Prospects
            </th>
            <td mat-cell *matCellDef="let prospect">
              {{ prospect?.prospect }}
            </td>
          </ng-container>

          <!-- Composite ID Column -->
          <ng-container matColumnDef="case_number">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="case_number">
              Case Number
            </th>
            <td mat-cell *matCellDef="let prospect">
              {{ prospect?.case_number ?? "-" }}
            </td>
          </ng-container>

          <!-- Program Column -->
          <ng-container matColumnDef="program">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Program</th>
            <td mat-cell *matCellDef="let prospect">
              <span class="program-cell" [title]="prospect?.program">
                {{ prospect?.program }}
              </span>
            </td>
          </ng-container>

          <!-- No of Transcripts Column -->
          <ng-container matColumnDef="no_of_transcripts">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              No of Transcripts
            </th>
            <td mat-cell *matCellDef="let prospect">
              {{ prospect?.no_of_transcripts ?? "-" }}
            </td>
          </ng-container>

          <!-- Start Date Column -->
          <ng-container matColumnDef="opportunity_start_date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Program Start Date
            </th>
            <td mat-cell *matCellDef="let prospect">
              {{
                prospect?.opportunity_start_date
                  ? (prospect?.opportunity_start_date | date: "MM/dd/yyyy")
                  : "-"
              }}
            </td>
          </ng-container>

          <!-- Assigned to Column -->
          <ng-container matColumnDef="advisor_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Assigned To
            </th>
            <td mat-cell *matCellDef="let prospect">
              <span class="advisor-cell" [title]="prospect?.advisor_name">{{
                prospect?.advisor_name ?? "-"
              }}</span>
            </td>
          </ng-container>

          <!-- Date Assigned Column -->
          <ng-container matColumnDef="date_assigned">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Case Created
            </th>
            <td mat-cell *matCellDef="let prospect">
              {{
                prospect?.date_assigned
                  ? (prospect?.date_assigned | date: "MM/dd/yyyy")
                  : "-"
              }}
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Salesforce Status
            </th>
            <td mat-cell *matCellDef="let prospect">
              <span
                class="status-badge"
                [ngClass]="getSalesforceStatusClass(prospect?.status)"
              >
                {{ prospect?.status || "-" }}
              </span>
            </td>
          </ng-container>

          <!-- Salesforce Last Updated Column -->
          <ng-container matColumnDef="salesforce_last_modified_date">
            <th mat-header-cell *matHeaderCellDef>Last Updated: Salesforce</th>
            <td mat-cell *matCellDef="let prospect">
              {{
                prospect?.salesforce_last_modified_date
                  ? (prospect.salesforce_last_modified_date
                    | date: "MM/dd/yyyy")
                  : "-"
              }}
            </td>
          </ng-container>

          <!-- Trace status -->
          <ng-container matColumnDef="tlo_status">
            <th mat-header-cell *matHeaderCellDef>Trace Status</th>
            <td mat-cell *matCellDef="let prospect">
              <span
                class="tlo-status"
                [ngClass]="getTloStatusClass(prospect?.trace_status)"
              >
                {{
                  prospect?.trace_status
                    ? (prospect.trace_status | titlecase)
                    : "-"
                }}
              </span>
            </td>
          </ng-container>

          <!-- Trace last modified column  -->
          <ng-container matColumnDef="trace_last_modified_date">
            <th mat-header-cell *matHeaderCellDef>Last Updated: Trace</th>
            <td mat-cell *matCellDef="let prospect">
              {{
                prospect?.trace_last_modified_date
                  ? (prospect.trace_last_modified_date
                    | date: "MM/dd/yyyy HH:mm" : "-0400")
                  : "-"
              }}
            </td>
          </ng-container>

          <ng-container matColumnDef="completedDate">
            <th mat-header-cell *matHeaderCellDef>Completed Date</th>
            <td mat-cell *matCellDef="let prospect">
              {{ prospect?.closed_date ?? "-" }}
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let prospect">
              @if (ComparisonNormalizer.string(prospect?.status) != "closed") {
                <button
                  class="view-btn"
                  (click)="viewDetails(prospect)"
                  title="View Details"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    loading="lazy"
                  >
                    <g clip-path="url(#clip0_1404_809)">
                      <path
                        d="M7.5 9C7.5 9.39782 7.65804 9.77936 7.93934 10.0607C8.22064 10.342 8.60218 10.5 9 10.5C9.39782 10.5 9.77936 10.342 10.0607 10.0607C10.342 9.77936 10.5 9.39782 10.5 9C10.5 8.60218 10.342 8.22064 10.0607 7.93934C9.77936 7.65804 9.39782 7.5 9 7.5C8.60218 7.5 8.22064 7.65804 7.93934 7.93934C7.65804 8.22064 7.5 8.60218 7.5 9Z"
                        stroke="#5F626B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M15.75 9C13.95 12 11.7 13.5 9 13.5C6.3 13.5 4.05 12 2.25 9C4.05 6 6.3 4.5 9 4.5C11.7 4.5 13.95 6 15.75 9Z"
                        stroke="#5F626B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1404_809">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              }
              <!-- Arize menu trigger -->

              <button
                class="arize-btn"
                [class.disabled]="!prospect?.arize_url[0]?.url"
                title="View Arize links"
                (click)="toggleArizeMenu($event, prospect)"
              >
                <svg
                  width="14"
                  height="12"
                  viewBox="0 0 14 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.54965 9.27527C7.26762 9.27527 7.84946 9.85808 7.84946 10.5761C7.8492 11.2938 7.26747 11.8759 6.54965 11.8759C5.83186 11.8758 5.25011 11.2938 5.24985 10.5761C5.24985 9.8581 5.8317 9.27529 6.54965 9.27527ZM5.10434 0.763552C5.79906 -0.254573 7.30016 -0.254462 7.99497 0.763552L12.9696 8.05261C13.2029 8.39474 13.1144 8.86214 12.7723 9.09558C12.4302 9.32872 11.9637 9.24023 11.7303 8.89832L6.75669 1.60925C6.65743 1.4638 6.44285 1.4638 6.3436 1.60925L1.36899 8.89832C1.13555 9.24029 0.669085 9.32881 0.326998 9.09558C-0.0151465 8.86212 -0.102744 8.39476 0.130709 8.05261L5.10434 0.763552Z"
                    fill="#5B5B5B"
                  />
                </svg>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            [ngClass]="{
              'flagged-row':
                ComparisonNormalizer.string(row.status) === 'flagged',
            }"
          ></tr>

          <tr class="mat-row" *matNoDataRow>
            <td
              class="mat-cell empty-result"
              [attr.colspan]="displayedColumns.length"
            >
              No Prospects Found
            </td>
          </tr>
        </table>
      </div>

      <div class="pagination-container">
        <div class="items-per-page">
          <select
            [(ngModel)]="pageSize"
            (change)="onPageSizeChange()"
            id="paginate"
          >
            <option [ngValue]="10">10</option>
            <option [ngValue]="20">20</option>
            <option [ngValue]="50">50</option>
          </select>

          @if (total > 0) {
            <span class="items-info">
              Prospects per Page •
              {{ pageIndex * pageSize + 1 }}–
              {{ Math.min((pageIndex + 1) * pageSize, total) }}
              of {{ total }} Prospects
            </span>
          }
        </div>

        <div class="pagination-controls">
          <button
            class="nav-btn"
            [disabled]="ComparisonNormalizer.number(pageIndex) === 0"
            (click)="changePage(pageIndex - 1)"
          >
            ‹
          </button>

          <div class="page-numbers">
            @for (page of visiblePages; track page) {
              <button
                class="page-btn"
                [class.active]="
                  ComparisonNormalizer.number(page) ===
                  ComparisonNormalizer.number(pageIndex) + 1
                "
                (click)="changePage(page - 1)"
              >
                {{ page }}
              </button>
            }
          </div>

          <button
            class="nav-btn"
            [disabled]="pageIndex >= totalPages - 1"
            (click)="changePage(pageIndex + 1)"
          >
            ›
          </button>
        </div>
      </div>

      <!-- Outside mat-table -->
      <div
        class="arize-popup"
        *ngIf="selectedArizeProspect"
        [style.left.px]="arizePopupPosition.left"
        [style.top.px]="arizePopupPosition.top"
      >
        <div class="arize-popup-header">ARIZE LINKS</div>

        <ul class="arize-links-list">
          <li
            class="arize-link-item"
            *ngFor="let link of getArizeLinks(selectedArizeProspect)"
          >
            <span
              class="arize-link-label"
              [title]="link.label"
              [attr.disabled]="!link.url ? true : null"
            >
              {{ link.label }}</span
            >

            <a
              [href]="link.url"
              target="_blank"
              rel="noopener noreferrer"
              title="View Trace in Arize"
              class="arize-link-hover"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.6765 10.0588V11.6647C13.6765 12.3071 13.6765 12.6284 13.5514 12.8737C13.4415 13.0895 13.266 13.265 13.0502 13.375C12.8048 13.5 12.4836 13.5 11.8412 13.5H6.5819C5.49432 13.5 4.60608 12.6309 4.58238 11.5436L4.5 7.76471V6.15882C4.5 5.51641 4.5 5.1952 4.62502 4.94984C4.73499 4.734 4.91047 4.55852 5.12631 4.44855C5.37167 4.32353 5.69288 4.32353 6.33529 4.32353H7.94118M10.8088 7.19118L14.25 3.75M14.25 7.19118V3.75H10.8088"
                  stroke="#006580"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
